import React from "react";
import { useLocation } from "react-router-dom";

function TemplateOne() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stringifiedParams = searchParams.get("params");
  const params = JSON.parse(stringifiedParams);
  console.log("==> params", params);

  return (
    <>
      <div>TemplateOne</div>
      {/* <div>{params}</div> */}
    </>
  );
}

export default TemplateOne;
